const PlugPage = () => {
  return (<>PlugPage</>)
}
export default PlugPage
